/*
 * Материал «жидкого стекла». Единственное место, где описаны фон, hairline-рамка,
 * верхний блик, тень и размытие поверхности — остальные компоненты строятся поверх.
 * Верхний блик отдельным свойством не пишется: он входит в каждый токен --shadow-*.
 *
 * Лестница материалов кита — четыре ступени, и каждая отличается от соседа и размытием,
 * и плотностью. Размытие растёт вместе с высотой поверхности над содержимым:
 *
 *   panel    28px / 180 %   градиент 42 -> 28 %   каркас страницы, крупные блоки
 *   card     14px / 150 %   градиент 42 -> 32 %   карточка внутри панели
 *   bar      30px / 185 %   плоские 72 %          прилипшая полоса, плавающая панель
 *   overlay  30px / 185 %   плоские 96 %          меню, поповер, карточка модалки
 *   inset       —           тень внутрь           утопленная подложка, стекла нет вовсе
 *
 * У ступени panel материала два, и это не шестая ступень, а одна роль в двух положениях:
 * --glass-panel, когда панель лежит на обоях приложения, и --glass-drawer (плоские 80 %),
 * когда её подняли поверх произвольного содержимого страницы. Переключает положение тот,
 * кто панель поднял, — подробности у .variantPanel ниже.
 *
 * Сверено с китом узел в узел: 284 карточки на blur(14px) saturate(150%), 30 панелей
 * на blur(28px) saturate(180%), меню и модалки на blur(30px) saturate(185%) при фоне
 * 0.94-0.97. Плотный оверлей — не ошибка: он закрывает то, из чего вырос, и обязан читаться
 * отдельным слоем. Плашка, которая приходит сама (тост), живёт на --glass-floating и
 * прозрачнее вдвое — это другая роль, и Surface её намеренно не выдаёт.
 *
 * Оси варианта переключаются классами, как у остальных примитивов кита;
 * атрибуты на корне остаются якорем для тестов и родительских стилей, но ничего не красят.
 */

.root {
  --surface-radius: var(--radius-card);
  --surface-padding: 0;
  --surface-shadow: none;
  --surface-blur: none;

  min-width: 0;
  padding: var(--surface-padding);
  overflow-wrap: break-word;
  border: var(--border-hairline) solid var(--color-border-glass);
  border-radius: var(--surface-radius);
  box-shadow: var(--surface-shadow);
  -webkit-backdrop-filter: var(--surface-blur);
  backdrop-filter: var(--surface-blur);
}

/* Уровни материала */

/*
 * Панель красится не прямо --glass-panel, а ролью --surface-panel-material, и это
 * единственная в материале точка подмены контекстом. Нужна она из-за одного случая:
 * ступень «панель» ложится и на обои приложения (колонка навигации, блок раздела), и поверх
 * произвольного содержимого страницы (шторка навигации ниже 1024px), а это разные материалы —
 * 28 % белого на худшем стопе рассчитаны на --bg-app и на белой таблице под шторкой роняют
 * вторичную тушь до 4.40:1, на чёрном фото — до 1.71:1.
 *
 * Почему роль, а не шестой вариант: вариант выбирает тот, кто рендерит Surface, — а это
 * AppSidebar, и он по своему контракту не знает, стоит он колонкой или выехал шторкой.
 * Решает это каркас, и до пропа он не дотягивается (сайдбар приезжает к нему слотом),
 * зато дотягивается наследованием: AppShell переопределяет роль на своей обёртке шторки,
 * значение --glass-drawer подставляется вниз по дереву, и материал по-прежнему описан
 * здесь одним объявлением, а не продублирован правилами каркаса.
 *
 * Значение по умолчанию стоит в tokens.css у :root, а не здесь: объявление на самом узле
 * поверхности било бы унаследованное и подмену бы отменило.
 *
 * Подменяется только заливка. Рамка, тень, радиус и размытие у шторки те же, что у панели:
 * контраст текста держит плотность, а не hairline, а второй слот ради правого края шириной
 * в одну вертикаль — абстракция раньше третьего повторения.
 */

.variantPanel {
  --surface-blur: var(--blur-panel);

  background: var(--surface-panel-material);
  border-color: var(--color-border-glass);
}

.variantCard {
  --surface-blur: var(--blur-card);

  background: var(--glass-card);
  border-color: var(--color-border-glass);
}

.variantInset {
  background: var(--color-surface-inset);
  border-color: var(--color-border-subtle);
}

.variantBar {
  --surface-blur: var(--blur-overlay);

  background: var(--glass-bar);
  border-color: var(--color-border-glass-strong);
}

.variantOverlay {
  --surface-blur: var(--blur-overlay);

  background: var(--glass-overlay);
  border-color: var(--color-border-glass-strong);
}

/* Размытие можно снять с любого уровня: длинные списки и слабые WebView */

.noBlur {
  --surface-blur: none;
}

/* Скругления: три ступени кита плюс отключение для полноширинных полос */

.radiusNone {
  --surface-radius: 0;
}

.radiusMenu {
  --surface-radius: var(--radius-menu);
}

.radiusCard {
  --surface-radius: var(--radius-card);
}

.radiusBlock {
  --surface-radius: var(--radius-block);
}

.radiusPanel {
  --surface-radius: var(--radius-panel);
}

/* Тени вместе с верхним бликом */

.elevationCard {
  --surface-shadow: var(--shadow-card);
}

.elevationPanel {
  --surface-shadow: var(--shadow-panel);
}

.elevationMenu {
  --surface-shadow: var(--shadow-menu);
}

.elevationModal {
  --surface-shadow: var(--shadow-modal);
}

/* Внутренние отступы */

.paddingXs {
  --surface-padding: var(--space-15);
}

.paddingSm {
  --surface-padding: var(--space-3);
}

.paddingMd {
  --surface-padding: var(--space-4);
}

.paddingLg {
  --surface-padding: var(--space-panel);
}

/* Кликабельная поверхность: плитка товара, карточка документа, быстрый заказ */

.interactive {
  transition:
    transform var(--transition-base),
    box-shadow var(--transition-base);
}

@media (hover: hover) {
  .interactive:hover {
    box-shadow: var(--shadow-lift);
    transform: translateY(calc(var(--space-05) * -1));
  }
}

.interactive:focus-visible {
  box-shadow: var(--ring-focus), var(--surface-shadow);
}

.interactive:active {
  box-shadow: var(--surface-shadow);
  transform: none;
}

/*
 * Высокая контрастность Windows. Заливку, цвет текста и рамку система переопределяет сама,
 * а градиент стекла и backdrop-filter — нет: панель продолжала бы белесо светиться поверх
 * системного фона, и в тёмной схеме HCM читалась бы молочным пятном. Материал снимается
 * целиком — в этом режиме поверхности различаются рамкой, а не толщиной стекла.
 */

@media (forced-colors: active) {
  .root {
    background: Canvas;
    -webkit-backdrop-filter: none;
    backdrop-filter: none;
  }
}
